import React, { useState } from "react";
import { createCampus, updateCampus } from '../../api/campus';
import styles from "../../styles/CampusStyles/PantallaDeCampus.module.css";
import globalStyles from "../../styles/PantallaDeProgramasAcademicos.v2.module.css";
import estudiantesStyles from "../../styles/EstudiantesStyles/Estudiantes.module.css";
import Sidebar from "../../components/Sidebar";
import HeaderGlobal from "../../components/HeaderGlobal";
import CampusTable from "./CampusTable";
import NewCampusModal from "./NewCampusModal";
import LoaderOverlay from "../../components/LoaderOverlay";
import { usePermissions } from "../../hooks/usePermissions";

function PantallaDeCampus() {
  const [openNew, setOpenNew] = useState(false);
  const [editData, setEditData] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  
  // Permisos del módulo Catálogos
  const { canEdit } = usePermissions();
  const puedeEditar = canEdit('Catálogos');

  const handleRegister = () => {
    setEditData(null);
    setOpenNew(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setOpenNew(true);
  };

  const handleClose = () => {
    setOpenNew(false);
    setEditData(null);
  };

  const handleSubmit = async (data) => {
    try {
      if (editData) {
        await updateCampus(editData.id, data);
      } else {
        await createCampus(data);
      }
      setRefreshKey(k => k + 1);
      setOpenNew(false);
      setEditData(null);
    } catch (err) {
      alert('Error al guardar campus');
    }
  };

  const handleSearch = () => {
    // En el futuro se puede filtrar CampusTable usando `query`
    console.log('Buscando campus con término:', query);
  };

  return (
    <div className={globalStyles.mainContainer}>
      <div className={globalStyles.layout}>
        <div className={globalStyles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={globalStyles.contentColumn}>
          <HeaderGlobal title="Campus" />
          <main className={globalStyles.mainContent}>
            <div className={globalStyles.contentArea}>
              <div className={globalStyles.contentWrapper} style={{ position: 'relative' }}>
                <LoaderOverlay visible={loading} label="Cargando campus..." />
                <div className={estudiantesStyles.searchSection}>
                  <div className={estudiantesStyles.searchCard}>
                    <div className={globalStyles.programsSearchRow}>
                      <div className={estudiantesStyles.searchInputGroup}>
                        <svg
                          className={estudiantesStyles.searchIcon}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="#898d8d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className={estudiantesStyles.searchInput}
                          placeholder="Buscar Campus..."
                          aria-label="Buscar Campus"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') handleSearch();
                          }}
                        />
                      </div>
                      <button
                        className={globalStyles.buscarButtonProgramas}
                        onClick={handleSearch}
                      >
                        BUSCAR
                      </button>
                      {puedeEditar && (
                        <button
                          type="button"
                          className={globalStyles.newProgramButton}
                          onClick={handleRegister}
                          aria-label="Registrar nuevo campus"
                        >
                          + Nuevo campus
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <CampusTable
                  key={refreshKey}
                  onEdit={handleEdit}
                  onLoadingChange={setLoading}
                />
                {openNew && (
                  <NewCampusModal
                    open={openNew}
                    onClose={handleClose}
                    onSubmit={handleSubmit}
                    initialData={editData}
                  />
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default PantallaDeCampus;
